<msf-form-builder
  [fields]="config.data.fields"
  [(model)]="model"
  flexDirection="row"
></msf-form-builder>
<div class="actions">
  <p-button
    [severity]="'secondary'"
    label="{{ 'Отменить' | translate }}"
    class="p-button-text button-secondary"
    (click)="cancel()">
  </p-button>

<!--  <app-save-button-->
<!--    [isSaving]="isLoading"-->
<!--    (save)="save()"-->
<!--  ></app-save-button>-->

  <button
    pButton type="button"
    label="{{ 'Save' | translate }}"
    class="p-button-primary"
    (click)="save()"
    [loading]="isLoading"
  ></button>
</div>
